import { config } from "../../config/config";
import { Observable } from "rxjs";
import { utilService } from "../utils";

/**
 * Api services for financial info component
 */
export const financialService = {
  getFinancialInfo,
};

function getFinancialInfo(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.financial_info + data.params, {
      method: "GET",
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        // console.log('result....', result)
        observer.next(result);
        observer.complete();
        // return result.responceObject.records
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}
